<template>
  <div class="create">
    <headd :mobile_title="mobile_title"></headd>

    <div class="createpost container">
      <div class="coupon_title hidden-sm hidden-xs">发布动态</div>
      <div class="post_form">
        <div class="form_1">
          <textarea
            class="textarea"
            v-model="info.writing"
            maxlength="150"
            placeholder="请输入分享内容（建议字数1-150字）"
          />
          <div class="foot">
            <div class="btn_item" v-if="info.topic">
              <img src="../../../static/circle/icon_13.png" class="ti_icon" />{{
                info.topic
              }}
            </div>
            <div class="btn_item" @click="addtopic">
              <img src="../../../static/circle/icon_14.png" class="ti_icon" />
              话题
            </div>
          </div>
          <div class="img_list">
            <div
              class="img_item"
              v-for="(item, index) in info.imgJson"
              @click="delImg"
              :data-index="index"
              :style="{
                backgroundImage: 'url(' + www + item.thumbfilepath + ')'
              }"
            >
              <img class="delete" src="../../../static/circle/icon_10.png" />
              <img :src="item.thumbfilepath" class="img" />
            </div>
            <div
              class="img_item"
              @click="setImgarr"
              v-show="info.imgJson.length < 9"
            >
              <img class="item_icon" src="../../../static/circle/icon_12.png" />
            </div>
          </div>
          <div class="btn_save" @click="btn_save">发布</div>
        </div>

        <div class="tag_list">
          <div class="tag_title">
            <img
              class="tag_icon"
              src="../../../static/circle/icon_11.png"
            />热门话题
          </div>
          <div class="list">
            <div
              class="tag_item"
              v-for="item in circle_list_hot"
              @click="selecttag($event)"
              :data-title="item.title"
              :key="item.title"
            >
              <img class="ti_icon" src="../../../static/circle/icon_13.png" />{{
                item.title
              }}
            </div>
          </div>
        </div>
      </div>
      <el-dialog
        title="请输入话题"
        :visible.sync="dialogFormVisible"
        width="7rem"
      >
        <div class="poup_box">
          <div class="box_info">
            <!-- <div class="box_title">请输入话题</div> -->
            <div class="box_input">
              <input
                type="text"
                v-model="topic"
                maxlength="15"
                placeholder="请输入话题"
                bindinput="bandOrderSum"
                @input="gettopic($event)"
              />
            </div>
          </div>
          <div class="box_btn">
            <div class="btn" @click="onClose">取消</div>
            <div class="btn red" @click="upOrder">确定</div>
          </div>
        </div>
      </el-dialog>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { Loading } from "element-ui";
let inputElement = null;
import axios from "axios";
import { gethotCircleTopic, getpublishSubmit } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
import { MessageBox, Toast } from "mint-ui";
export default {
  data() {
    return {
      mobile_title: "发布动态",
      circle_list_hot: [],
      writing: "",
      topic: "",
      info: {
        uid: localStorage.getItem("userId"),
        writing: "",
        imgJson: [],
        topic: ""
      },
      www: this.common.www_img,
      dialogFormVisible: false,
      apiurl: this.common.apiurl
    };
  },

  onShow() {
    this.getCircleHot();
    this.$logindex();
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getCircleHot();
  },
  methods: {
    async btn_save() {
      var _self = this;
      var data = _self.info;
      console.log(data);

      if (localStorage.getItem("sessionToken")) {
        if (data.writing == "") {
          this.$toast("请输入分享内容");
          return false;
        }
        if (data.writing.length > 150) {
          this.$toast("内容不可超过150个字");

          return false;
        }
        if (data.imgJson.length == 0) {
          this.$toast("请上传图片");
          return false;
        }
        if (data.topic == "") {
          this.$toast("请添加话题");
          return false;
        }
        if (data.topic.length > 15) {
          this.$toast("话题不可超过15个字");
          return false;
        }
        var parm = {
          uid: localStorage.getItem("userId"),
          writing: data.writing,
          imgJson: JSON.stringify(data.imgJson),
          topic: data.topic
        };
        const res = await getpublishSubmit(parm);
        if (res.status == 1) {
          this.$toast({
            message: "提交成功",
            type: "success"
          });
          setTimeout(function() {
            _self.$router.push({
              path: "circle_index"
            });
          }, 2500);
          _self.info.writing = "";
          _self.info.imgJson = [];
          _self.info.topic = "";

          // return uni.showToast({
          //   title: "提交成功",
          //   complete: function(res) {
          //     uni.navigateBack({
          //       delta: 1
          //     });
          //   }
          // });
        }
      } else {
        this.$toast("请登录");
        setTimeout(function() {
          _self.$router.push({
            path: "login"
          });
        }, 2500);
      }
    },
    async getCircleHot() {
      var _slef = this;
      var data = {
        skip: 1,
        limit: 15
      };
      const res = await gethotCircleTopic(data);
      _slef.circle_list_hot = res.data.data.hottopic;
    },
    setImgarr() {
      var that = this;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传图片大小不能超过 50MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$toast("请选择图片文件");
        } else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("circleimg", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadCircleImg", formData, config)
              .then(uploadFileRes => {
                //console.log(uploadFileRes.data);
                //var res = JSON.parse(uploadFileRes.data);
                //console.log(res.data);
                var res = uploadFileRes.data;
                console.log(res);
                if (res.status == 1) {
                  that.info.imgJson.push(uploadFileRes.data.data);
                } else {
                  that.$toast(res.msg);
                }

                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });
                inputElement = null;
              });
          };
        }
      }
    },
    delImg(e) {
      //console.log(e)
      var _self = this;
      var index = e.currentTarget.dataset.index;

      MessageBox.confirm("是否删除图片")
        .then(action => {
          Toast({
            message: "删除成功"
          });
          var imgJson = _self.info.imgJson;
          imgJson.splice(index, 1);
          _self.info.imgJson = imgJson;
        })
        .catch(() => {
          Toast({
            message: "已取消删除"
          });
        });

      //   this.$confirm("是否删除图片", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   })
      //     .then(() => {
      //       this.$message({
      //         type: "success",
      //         message: "删除成功!"
      //       });
      //       var imgJson = _self.info.imgJson;
      //       imgJson.splice(index, 1);
      //       _self.info.imgJson = imgJson;
      //     })
      //     .catch(() => {
      //       this.$message({
      //         type: "info",
      //         message: "已取消删除"
      //       });
      //     });
    },

    gettopic(e) {
      console.log(e.target.value);
      this.info.topic = e.target.value;
    },
    selecttag(e) {
      var topic = e.target.dataset.title;
      var _self = this;
      _self.info.topic = topic;
    },

    addtopic() {
      this.dialogFormVisible = true;
    },
    onClose() {
      this.dialogFormVisible = false;
    },
    upOrder() {
      var _self = this;
      _self.info.topic = _self.topic;
      this.dialogFormVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.create {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    .container {
      padding: 0;
    }
  }
}
.createpost {
  margin: 0.32rem auto;
  width: 8rem;
  @media (max-width: 991px) {
    width: 100%;
  }
  .coupon_title {
    font-size: 0.26rem;
    margin-bottom: 0.32rem;
    text-align: left;
  }
  .post_form {
    flex-direction: column;
    position: relative;
    .form_1 {
      width: 100%;
      padding: 0.2rem;
      background: #f9f9f9;
      flex-direction: column;
      border-radius: 0.12rem;
      margin-bottom: 0.3rem;
      position: relative;
      .textarea {
        width: 100%;
        font-size: 0.2rem;
        color: #1b1c33;
        line-height: 0.3rem;
        height: 1.5rem;
        border: 0;
        background: none;
        @media (max-width: 991px) {
          font-size: 0.3rem;
          line-height: 0.42rem;
        }
      }
      .foot {
        text-align: left;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .btn_item {
          cursor: pointer;
          align-items: center;
          margin: 0 0.15rem 0.2rem 0.15rem;
          display: flex;

          padding: 0 0.17rem;
          line-height: 0.3rem;
          height: 0.3rem;
          border-radius: 0.15rem;
          border: 1px solid #1395ff;
          font-size: 0.16rem;
          .ti_icon {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.05rem;
            display: flex;
            align-items: center;
          }

          color: #1395ff;
          @media (max-width: 991px) {
            cursor: pointer;

            margin: 0 0.15rem 0.2rem 0.15rem;
            display: flex;
            line-height: 100%;
            line-height: 0.42rem;
            padding: 0;
            font-size: 0.3rem;
            border-radius: 0.21rem;
            border: 1px solid #1395ff;
            padding: 0.17rem 0.17rem;

            .ti_icon {
              width: 0.22rem;
              height: 0.22rem;
              margin-right: 0.05rem;
            }
          }
        }
      }
    }
    .img_list {
      width: 100%;
      padding: 0.22rem 0.2rem;
      flex-wrap: wrap;
      display: flex;
      .img_item {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.1rem;
        margin-right: 0.2rem;
        margin-bottom: 0.2rem;
        background-color: #ffffff;
        align-items: center;
        justify-content: center;
        border: 1px solid #979797;
        position: relative;
        background-position: center;
        background-size: cover;
        display: flex;
        @media (max-width: 991px) {
          width: 1.2rem;
          height: 1.2rem;
        }
        .delete {
          position: absolute;
          top: -0.1rem;
          right: -0.1rem;
          width: 0.2rem;
          height: 0.2rem;
          z-index: 2;
          @media (max-width: 991px) {
            width: 0.4rem;
            height: 0.4rem;
          }
        }
        .img {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 0.1rem;
          opacity: 0;
        }
        .item_icon {
          width: 0.25rem;
          height: 0.24rem;
          @media (max-width: 991px) {
            width: 0.5rem;
            height: 0.48rem;
          }
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
    .tag_list {
      margin-top: 0.5rem;
      justify-content: center;
      flex-direction: column;
      .tag_title {
        align-items: center;
        justify-content: center;
        margin-bottom: 0.3rem;
        display: flex;
        .tag_icon {
          width: 0.222rem;
          height: 0.22rem;
          margin-right: 0.1rem;
        }
        font-size: 0.2rem;
        line-height: 0.33rem;
        color: #1b1c33;
        @media (max-width: 991px) {
          font-size: 0.32rem;
          line-height: 0.44rem;
          .tag_icon {
            width: 0.36rem;
            height: 0.36rem;
            margin-right: 0.1rem;
          }
        }
      }
      .list {
        justify-content: center;
        flex-wrap: wrap;
        display: flex;
        .tag_item {
          align-items: center;
          margin: 0 0.1rem 0.2rem 0.1rem;
          display: flex;
          cursor: pointer;
          .ti_icon {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.05rem;
            @media (max-width: 991px) {
              width: 0.22rem;
              height: 0.22rem;
            }
          }
          padding: 0 0.17rem;
          line-height: 0.42rem;
          height: 0.42rem;
          border-radius: 0.21rem;
          border: 1px solid #1395ff;
          font-size: 0.18rem;

          color: #1395ff;
          @media (max-width: 991px) {
            font-size: 0.3rem;
            line-height: 0.42rem;
          }
        }
      }
    }
    .btn_save {
      //   position: absolute;
      //   right: 0.5rem;
      //   bottom: 0.5rem;
      width: 1rem;
      height: 0.4rem;
      line-height: 0.4rem;
      background: #1395ff;
      border-radius: 0.2rem;
      font-size: 0.2rem;
      color: #ffffff;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin: auto;
      @media (max-width: 991px) {
        width: 1.56rem;
        font-size: 0.28rem;
        height: 0.5rem;
        line-height: 0.5rem;
        border-radius: 0.25rem;
      }
    }
  }
}
.poup_box {
  width: 6.4rem;
  height: auto;
  flex-direction: column;
  background-color: #ffffff;

  .box_info {
    padding: 0rem 0.43rem 0 0.43rem;
    flex-direction: column;
    .box_title {
      font-size: 0.2rem;
      font-weight: bold;
      color: #333333;
      line-height: 0.28rem;
      margin-bottom: 0.31rem;
    }
    .box_title.center {
      text-align: center;
    }
    .box_type {
      margin-bottom: 0.2rem;
      display: flex;
      justify-content: space-around;
      .btn {
        width: 1.6rem;
        height: 0.4rem;
        border-radius: 0.2rem;
        line-height: 0.4rem;
        font-size: 0.2rem;
        text-align: center;
        border: 1px solid #ccc;
      }
      .btn.active {
        border: 1px solid #ff3e3c;
        color: #ff3e3c;
      }
    }

    .box_input {
      width: 5.5rem;
      background: #f5f5f5;
      border-radius: 0.14rem;
      padding: 0.28rem;
      margin-bottom: 0.57rem;
      input {
        width: 100%;
        font-size: 0.2rem;
        color: #999999;
        line-height: 0.24rem;
        border: 0;
        background: transparent;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }
    }
  }
  .box_btn {
    display: flex;
    border-top: 1px solid #eeeeee;
    height: 1rem;
    justify-content: space-between;
    .btn {
      margin: 0.24rem 0;
      flex: 1;
      font-size: 0.2rem;
      color: #333333;
      line-height: 0.5rem;
      height: 0.5rem;
      text-align: center;
      border-right: 0.01rem solid #eeeeee;
      justify-content: center;
      align-items: center;
      &:last-child {
        border-right: 0;
      }
    }
    .btn.red {
      color: #ff3e3c;
    }
  }
  @media (max-width: 991px) {
    .btn {
      font-size: 0.3rem !important;
      line-height: 0.3rem !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/circle/createpost.vue